<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" style="height:525px" @click.stop>
                <div style="text-align:right">
                    <button class="transparent" type="button" @click="$emit('close')">
                        <img style="margin-top:5px;height:40px;padding-right:5px" :src="require('../assets/icon_clear.svg')"/>
                    </button>
                </div>
                <video-player class="vjs-custom-skin"
                    ref="videoPlayer"
                    :options="playerOptions"
                    :playsinline="true"
                    :src="playVideoSrcUrl"
                    @play="onPlayerPlay($event)"
                    @pause="onPlayerPause($event)"
                    @ended="onPlayerEnded($event)"
                    @waiting="onPlayerWaiting($event)"
                    @playing="onPlayerPlaying($event)"
                    @loadeddata="onPlayerLoadeddata($event)"
                    @timeupdate="onPlayerTimeupdate($event)"
                    @canplay="onPlayerCanplay($event)"
                    @canplaythrough="onPlayerCanplaythrough($event)"
                    @statechanged="playerStateChanged($event)"
                    @ready="playerReadied">
                </video-player>
            </div>
        </div>
    </transition>
</template>

<script>

export default {
    data() {
        return {
            playerOptions: {
                // videojs options
                height:500,
                autoplay: true,
                muted: false,
                language: 'en',
                playbackRates: [0.5, 1.0, 1.5, 2.0],
                sources: [{
                    type: "video/mp4",
                    src: null
                }],
                poster: "/static/images/author.jpg",
            }
        }
    },
    created() {
        this.playerOptions.sources[0].src = this.playVideoSrc;
    },
    mounted() {
    },
    computed: {
        player() {
            return this.$refs.videoPlayer.player
        }
    },
    methods: {
        // listen event
        onPlayerPlay(player) {
        },
        onPlayerPause(player) {
        },
        playerStateChanged(playerCurrentState) {
        },

        // player is ready
        playerReadied(player) {
        }
    },
    components: {
    },
    props: [ 'playVideoSrc' ]
}
</script>
<style scoped>
.video-player-box {
    width: 400px;
    height: 400px;
}
</style scoped>
